/** Empty means "the server's own value"; otherwise a whole number of calls from 1 to 10. */
function isConcurrencyValid(value: string): boolean {
	if (value === '') {
		return true;
	}

	const calls = Number(value);

	return Number.isInteger(calls) && calls >= 1 && calls <= 10;
}

export default isConcurrencyValid;
